module.exports = __webpack_public_path__ + "2bddc3578817a5613db2983ed08835e9.png";